import Layout from 'components/app/layout'
import React from 'react'
import {useCopyToClipboard} from 'react-use'
import {twMerge} from 'tailwind-merge'
import {renderToString} from 'react-dom/server'
import toast from 'react-hot-toast'
import cx from 'classnames'

const BrandPage = () => {
  return (
    <Layout
      meta={{
        title: 'Brand Assets',
        ogImage: {
          url: 'https://res.cloudinary.com/epic-web/image/upload/v1687188572/brand-card_2x.png',
        },
      }}
    >
      <header className="mx-auto w-full max-w-screen-lg px-5 pb-3 pt-10 sm:pb-5 sm:pt-20">
        <h1 className="text-center text-3xl font-bold">Brand Assets</h1>
      </header>
      <main className="mx-auto w-full max-w-screen-lg space-y-24 px-5 pb-32 pt-10">
        <EpicWebSection />
        <EpicStackSection />
        <DeployEpicStackSection />
        <EpicWebCampSection />
      </main>
    </Layout>
  )
}

export default BrandPage

const DeployEpicStackSection = () => {
  return (
    <div>
      <h2
        id="deploy-epic-stack"
        className="w-full border-b border-black/5 pb-2 text-2xl font-bold dark:border-white/5"
      >
        Deploy Epic Stack Buttons
      </h2>
      <section className="space-y-12 pt-12">
        <article>
          <Grid>
            <LogoCard
              hasGrayscale={false}
              className="bg-[#140C3E]"
              logo={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="175"
                  height="32"
                  fill="none"
                  viewBox="0 0 175 32"
                >
                  <rect width="175" height="32" fill="#6A24FF" rx="5" />
                  <rect
                    width="174"
                    height="31"
                    x=".5"
                    y=".5"
                    stroke="#1A1A1A"
                    strokeOpacity=".14"
                    rx="4.5"
                  />
                  <path
                    fill="#F6F6F6"
                    d="M45.424 11.06c1.577 0 2.79.434 3.64 1.302.859.859 1.288 2.086 1.288 3.682 0 1.587-.42 2.81-1.26 3.668-.83.859-2.025 1.288-3.584 1.288h-3.36v-9.94h3.276Zm0 8.386c1.045 0 1.825-.28 2.338-.84.523-.57.784-1.423.784-2.562 0-1.157-.261-2.016-.784-2.576-.513-.57-1.293-.854-2.338-.854h-1.512v6.832h1.512Zm6.145-2.156c0-.784.15-1.465.448-2.044a3.201 3.201 0 0 1 1.274-1.358c.55-.317 1.19-.476 1.918-.476.644 0 1.222.145 1.736.434.513.29.924.728 1.232 1.316.308.579.471 1.293.49 2.142v.462h-5.278c.037.635.214 1.13.532 1.484.317.345.746.518 1.288.518a1.678 1.678 0 0 0 1.582-1.036l1.778.126a3.141 3.141 0 0 1-1.26 1.694c-.607.41-1.307.616-2.1.616-.728 0-1.367-.159-1.918-.476a3.201 3.201 0 0 1-1.274-1.358c-.299-.588-.448-1.27-.448-2.044Zm5.306-.714c-.075-.607-.266-1.055-.574-1.344a1.51 1.51 0 0 0-1.092-.434c-.504 0-.91.159-1.218.476-.308.308-.504.742-.588 1.302h3.472Zm3.345-2.996h1.638l.056 1.554-.14-.182c.187-.495.48-.873.882-1.134.41-.27.905-.406 1.484-.406.69 0 1.274.173 1.75.518.476.345.83.812 1.064 1.4.243.579.364 1.232.364 1.96s-.121 1.386-.364 1.974a3.103 3.103 0 0 1-1.064 1.386c-.476.345-1.06.518-1.75.518a2.92 2.92 0 0 1-1.05-.182 2.22 2.22 0 0 1-.798-.532 2.476 2.476 0 0 1-.504-.868l.168-.14V23.1H60.22v-9.52Zm1.596 3.71c0 .448.065.859.196 1.232.14.364.35.658.63.882.28.224.62.336 1.022.336.607 0 1.064-.233 1.372-.7.317-.467.476-1.05.476-1.75 0-.69-.159-1.274-.476-1.75-.308-.476-.765-.714-1.372-.714-.401 0-.742.117-1.022.35-.28.224-.49.523-.63.896-.13.364-.196.77-.196 1.218Zm8.974-6.23v8.05c0 .168.042.299.126.392.094.084.224.126.392.126h.588V21h-1.022c-.55 0-.994-.163-1.33-.49-.326-.327-.49-.77-.49-1.33v-8.12h1.736Zm5.706 10.108c-.728 0-1.368-.159-1.918-.476a3.318 3.318 0 0 1-1.274-1.358c-.3-.588-.448-1.27-.448-2.044 0-.784.149-1.465.448-2.044a3.318 3.318 0 0 1 1.274-1.358c.55-.317 1.19-.476 1.918-.476s1.367.159 1.918.476c.55.317.975.77 1.274 1.358.298.579.448 1.26.448 2.044 0 .775-.15 1.456-.448 2.044a3.202 3.202 0 0 1-1.274 1.358c-.551.317-1.19.476-1.918.476Zm0-1.428c.597 0 1.054-.215 1.372-.644.317-.43.476-1.031.476-1.806 0-.775-.16-1.377-.476-1.806-.318-.43-.775-.644-1.372-.644-.588 0-1.046.215-1.372.644-.318.43-.476 1.031-.476 1.806 0 .775.158 1.377.476 1.806.326.43.784.644 1.372.644Zm5.854-6.16 1.988 5.6 1.932-5.6h1.708l-2.954 8.218c-.159.448-.392.775-.7.98-.308.215-.705.322-1.19.322H82v-1.344h.84c.205 0 .369-.042.49-.126a.71.71 0 0 0 .28-.364l.224-.546h-.518l-2.674-7.14h1.708Zm17.047-2.52v1.554h-4.872v2.632h4.704v1.526h-4.704v2.674h4.984V21h-6.748v-9.94h6.636Zm1.866 2.52h1.638l.056 1.554-.14-.182c.187-.495.481-.873.882-1.134.411-.27.905-.406 1.484-.406.691 0 1.274.173 1.75.518a3.09 3.09 0 0 1 1.064 1.4c.243.579.364 1.232.364 1.96s-.121 1.386-.364 1.974a3.101 3.101 0 0 1-1.064 1.386c-.476.345-1.059.518-1.75.518-.383 0-.733-.06-1.05-.182a2.22 2.22 0 0 1-.798-.532 2.464 2.464 0 0 1-.504-.868l.168-.14V23.1h-1.736v-9.52Zm1.596 3.71c0 .448.065.859.196 1.232.14.364.35.658.63.882.28.224.621.336 1.022.336.607 0 1.064-.233 1.372-.7.317-.467.476-1.05.476-1.75 0-.69-.159-1.274-.476-1.75-.308-.476-.765-.714-1.372-.714-.401 0-.742.117-1.022.35-.28.224-.49.523-.63.896-.131.364-.196.77-.196 1.218Zm8.767-3.71V21h-1.736v-7.42h1.736Zm.042-2.52v1.47h-1.806v-1.47h1.806Zm6.824 5.222c-.065-.457-.247-.812-.546-1.064a1.595 1.595 0 0 0-1.064-.378c-.588 0-1.045.215-1.372.644-.317.43-.476 1.031-.476 1.806 0 .775.159 1.377.476 1.806.327.43.784.644 1.372.644.439 0 .808-.13 1.106-.392.299-.27.486-.653.56-1.148l1.792.084a3.166 3.166 0 0 1-.574 1.54c-.317.43-.728.76-1.232.994a3.822 3.822 0 0 1-1.652.35c-.728 0-1.367-.159-1.918-.476a3.32 3.32 0 0 1-1.274-1.358c-.298-.588-.448-1.27-.448-2.044 0-.784.15-1.465.448-2.044a3.32 3.32 0 0 1 1.274-1.358c.551-.317 1.19-.476 1.918-.476.588 0 1.13.112 1.624.336.495.224.896.546 1.204.966.318.42.509.91.574 1.47l-1.792.098Zm8.181 1.386c.084.392.229.737.434 1.036.205.29.476.513.812.672.336.159.728.238 1.176.238.373 0 .691-.047.952-.14.271-.093.481-.233.63-.42.149-.187.219-.415.21-.686 0-.41-.191-.751-.574-1.022-.373-.28-.999-.527-1.876-.742-1.055-.252-1.876-.611-2.464-1.078-.588-.467-.882-1.078-.882-1.834 0-.579.145-1.083.434-1.512.299-.43.714-.76 1.246-.994.541-.233 1.162-.35 1.862-.35.719 0 1.358.14 1.918.42a3.24 3.24 0 0 1 1.344 1.148c.336.495.546 1.064.63 1.708l-1.792.098a1.94 1.94 0 0 0-.35-.966 1.84 1.84 0 0 0-.742-.644 2.343 2.343 0 0 0-1.036-.224c-.513 0-.929.121-1.246.364a1.122 1.122 0 0 0-.462.966c0 .29.098.532.294.728.205.196.448.35.728.462.28.103.649.215 1.106.336l.21.056c1.083.27 1.927.649 2.534 1.134.616.485.924 1.101.924 1.848 0 .607-.163 1.13-.49 1.568-.327.439-.77.77-1.33.994a4.933 4.933 0 0 1-1.848.336c-.765 0-1.456-.14-2.072-.42a3.586 3.586 0 0 1-1.456-1.19c-.355-.513-.56-1.11-.616-1.792l1.792-.098Zm9.909-5.768v6.846c0 .29.07.509.21.658.15.15.36.224.63.224h1.12V21h-1.386c-.756 0-1.33-.191-1.722-.574-.392-.383-.588-.943-.588-1.68V11.9h1.736Zm1.96 1.68v1.358h-4.858V13.58h4.858Zm1.186 2.254c.149-.765.508-1.358 1.078-1.778.569-.43 1.302-.644 2.198-.644 1.064 0 1.871.27 2.422.812.55.541.826 1.33.826 2.366v2.59c0 .196.037.336.112.42.084.075.2.112.35.112h.28V21l-.434.014h-.056c-.252.01-.509-.01-.77-.056a1.41 1.41 0 0 1-.672-.322c-.196-.168-.308-.425-.336-.77-.187.383-.49.695-.91.938-.42.243-.934.364-1.54.364-.766 0-1.405-.191-1.918-.574a1.859 1.859 0 0 1-.756-1.54c0-.467.107-.845.322-1.134.224-.29.532-.518.924-.686.401-.168.924-.313 1.568-.434l2.086-.42c-.01-.57-.136-.99-.378-1.26-.243-.28-.616-.42-1.12-.42-.392 0-.719.107-.98.322-.252.205-.425.509-.518.91l-1.778-.098Zm1.666 3.164c0 .27.112.495.336.672.233.168.564.252.994.252.345 0 .653-.084.924-.252.28-.168.494-.42.644-.756.158-.345.238-.76.238-1.246v-.07l-1.428.252-.252.042c-.346.065-.616.13-.812.196a1.011 1.011 0 0 0-.462.322c-.122.14-.182.336-.182.588Zm11.743-2.716c-.066-.457-.248-.812-.546-1.064a1.599 1.599 0 0 0-1.064-.378c-.588 0-1.046.215-1.372.644-.318.43-.476 1.031-.476 1.806 0 .775.158 1.377.476 1.806.326.43.784.644 1.372.644.438 0 .807-.13 1.106-.392.298-.27.485-.653.56-1.148l1.792.084a3.186 3.186 0 0 1-.574 1.54c-.318.43-.728.76-1.232.994a3.828 3.828 0 0 1-1.652.35c-.728 0-1.368-.159-1.918-.476a3.314 3.314 0 0 1-1.274-1.358c-.299-.588-.448-1.27-.448-2.044 0-.784.149-1.465.448-2.044a3.314 3.314 0 0 1 1.274-1.358c.55-.317 1.19-.476 1.918-.476.588 0 1.129.112 1.624.336a3 3 0 0 1 1.204.966c.317.42.508.91.574 1.47l-1.792.098Zm4.973-5.222v5.922l3.066-3.402h2.156l-2.898 3.08 3.024 4.34h-1.96l-2.198-3.29-1.19 1.288V21h-1.736v-9.94h1.736Z"
                  />
                  <path
                    fill="#F6F6F6"
                    fillRule="evenodd"
                    d="m15.03 12.697-.526 1.807-1.804.527L9 9l6.03 3.697Zm1.94 0 .526 1.807 1.804.527L23 9l-6.03 3.697Zm.526 4.8-.526 1.807L23 23l-3.7-6.03-1.804.526Zm-2.465 1.807-.527-1.808-1.804-.526L9 23l6.03-3.697h.001Z"
                    clipRule="evenodd"
                  />
                  <path stroke="#1A1A1A" strokeOpacity=".14" d="M31.5 1v30" />
                </svg>
              }
            />
            <LogoCard
              hasGrayscale={false}
              className="bg-[#140C3E]"
              logo={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="99"
                  height="32"
                  fill="none"
                  viewBox="0 0 99 32"
                >
                  <rect width="99" height="32" fill="#6A24FF" rx="5" />
                  <rect
                    width="98"
                    height="31"
                    x=".5"
                    y=".5"
                    stroke="#1A1A1A"
                    strokeOpacity=".14"
                    rx="4.5"
                  />
                  <path
                    fill="#F6F6F6"
                    d="M45.424 11.06c1.577 0 2.79.434 3.64 1.302.859.859 1.288 2.086 1.288 3.682 0 1.587-.42 2.81-1.26 3.668-.83.859-2.025 1.288-3.584 1.288h-3.36v-9.94h3.276Zm0 8.386c1.045 0 1.825-.28 2.338-.84.523-.57.784-1.423.784-2.562 0-1.157-.261-2.016-.784-2.576-.513-.57-1.293-.854-2.338-.854h-1.512v6.832h1.512Zm6.145-2.156c0-.784.15-1.465.448-2.044a3.201 3.201 0 0 1 1.274-1.358c.55-.317 1.19-.476 1.918-.476.644 0 1.222.145 1.736.434.513.29.924.728 1.232 1.316.308.579.471 1.293.49 2.142v.462h-5.278c.037.635.214 1.13.532 1.484.317.345.746.518 1.288.518a1.678 1.678 0 0 0 1.582-1.036l1.778.126a3.141 3.141 0 0 1-1.26 1.694c-.607.41-1.307.616-2.1.616-.728 0-1.367-.159-1.918-.476a3.201 3.201 0 0 1-1.274-1.358c-.299-.588-.448-1.27-.448-2.044Zm5.306-.714c-.075-.607-.266-1.055-.574-1.344a1.51 1.51 0 0 0-1.092-.434c-.504 0-.91.159-1.218.476-.308.308-.504.742-.588 1.302h3.472Zm3.345-2.996h1.638l.056 1.554-.14-.182c.187-.495.48-.873.882-1.134.41-.27.905-.406 1.484-.406.69 0 1.274.173 1.75.518.476.345.83.812 1.064 1.4.243.579.364 1.232.364 1.96s-.121 1.386-.364 1.974a3.103 3.103 0 0 1-1.064 1.386c-.476.345-1.06.518-1.75.518a2.92 2.92 0 0 1-1.05-.182 2.22 2.22 0 0 1-.798-.532 2.476 2.476 0 0 1-.504-.868l.168-.14V23.1H60.22v-9.52Zm1.596 3.71c0 .448.065.859.196 1.232.14.364.35.658.63.882.28.224.62.336 1.022.336.607 0 1.064-.233 1.372-.7.317-.467.476-1.05.476-1.75 0-.69-.159-1.274-.476-1.75-.308-.476-.765-.714-1.372-.714-.401 0-.742.117-1.022.35-.28.224-.49.523-.63.896-.13.364-.196.77-.196 1.218Zm8.974-6.23v8.05c0 .168.042.299.126.392.094.084.224.126.392.126h.588V21h-1.022c-.55 0-.994-.163-1.33-.49-.326-.327-.49-.77-.49-1.33v-8.12h1.736Zm5.706 10.108c-.728 0-1.368-.159-1.918-.476a3.318 3.318 0 0 1-1.274-1.358c-.3-.588-.448-1.27-.448-2.044 0-.784.149-1.465.448-2.044a3.318 3.318 0 0 1 1.274-1.358c.55-.317 1.19-.476 1.918-.476s1.367.159 1.918.476c.55.317.975.77 1.274 1.358.298.579.448 1.26.448 2.044 0 .775-.15 1.456-.448 2.044a3.202 3.202 0 0 1-1.274 1.358c-.551.317-1.19.476-1.918.476Zm0-1.428c.597 0 1.054-.215 1.372-.644.317-.43.476-1.031.476-1.806 0-.775-.16-1.377-.476-1.806-.318-.43-.775-.644-1.372-.644-.588 0-1.046.215-1.372.644-.318.43-.476 1.031-.476 1.806 0 .775.158 1.377.476 1.806.326.43.784.644 1.372.644Zm5.854-6.16 1.988 5.6 1.932-5.6h1.708l-2.954 8.218c-.159.448-.392.775-.7.98-.308.215-.705.322-1.19.322H82v-1.344h.84c.205 0 .369-.042.49-.126a.71.71 0 0 0 .28-.364l.224-.546h-.518l-2.674-7.14h1.708Z"
                  />
                  <path
                    fill="#F6F6F6"
                    fillRule="evenodd"
                    d="m15.03 12.697-.526 1.807-1.804.527L9 9l6.03 3.697Zm1.94 0 .526 1.807 1.804.527L23 9l-6.03 3.697Zm.526 4.8-.526 1.807L23 23l-3.7-6.03-1.804.526Zm-2.465 1.807-.527-1.808-1.804-.526L9 23l6.03-3.697h.001Z"
                    clipRule="evenodd"
                  />
                  <path stroke="#1A1A1A" strokeOpacity=".14" d="M31.5 1v30" />
                </svg>
              }
            />
            <LogoCard
              hasGrayscale={false}
              className="bg-black"
              logo={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="175"
                  height="32"
                  fill="none"
                  viewBox="0 0 175 32"
                >
                  <rect width="175" height="32" fill="#1A1A1A" rx="5" />
                  <rect
                    width="174"
                    height="31"
                    x=".5"
                    y=".5"
                    stroke="#fff"
                    strokeOpacity=".14"
                    rx="4.5"
                  />
                  <path
                    fill="#EDEDED"
                    d="M45.396 11.06c1.55 0 2.744.434 3.584 1.302.85.859 1.274 2.086 1.274 3.682 0 1.587-.415 2.81-1.246 3.668-.821.859-1.997 1.288-3.528 1.288h-3.262v-9.94h3.178Zm0 8.568c1.11 0 1.941-.299 2.492-.896.55-.597.826-1.493.826-2.688 0-1.213-.275-2.119-.826-2.716-.55-.597-1.381-.896-2.492-.896h-1.694v7.196h1.694Zm6.132-2.338c0-.784.145-1.465.434-2.044.29-.588.7-1.04 1.232-1.358.532-.317 1.148-.476 1.848-.476a3.3 3.3 0 0 1 1.638.406c.495.27.892.69 1.19 1.26.308.57.476 1.279.504 2.128l.014.504h-5.334c.056.7.257 1.241.602 1.624.346.383.808.574 1.386.574.374 0 .714-.098 1.022-.294.308-.205.537-.485.686-.84l1.526.112a3.116 3.116 0 0 1-1.218 1.666 3.44 3.44 0 0 1-2.016.616c-.7 0-1.316-.159-1.848-.476a3.183 3.183 0 0 1-1.232-1.344c-.289-.588-.434-1.274-.434-2.058Zm5.32-.7c-.093-.663-.303-1.148-.63-1.456a1.654 1.654 0 0 0-1.176-.462c-.54 0-.98.168-1.316.504-.336.336-.55.807-.644 1.414h3.766Zm3.21-3.01h1.358l.056 1.568-.14-.21c.186-.495.48-.873.882-1.134.41-.261.91-.392 1.498-.392.7 0 1.287.177 1.763.532.477.345.831.812 1.065 1.4.242.579.363 1.227.363 1.946 0 .719-.12 1.372-.364 1.96a3.196 3.196 0 0 1-1.064 1.4c-.475.345-1.063.518-1.763.518-.393 0-.747-.056-1.065-.168a2.22 2.22 0 0 1-.797-.532 2.494 2.494 0 0 1-.505-.854l.169-.182V23.1h-1.457v-9.52Zm1.316 3.71c0 .467.07.896.21 1.288.149.392.373.71.671.952.3.243.672.364 1.12.364.663 0 1.158-.247 1.484-.742.337-.504.505-1.125.505-1.862 0-.728-.169-1.344-.505-1.848-.335-.504-.83-.756-1.483-.756-.448 0-.822.121-1.12.364a2.2 2.2 0 0 0-.672.952c-.14.392-.21.821-.21 1.288Zm8.795-6.23v8.246c0 .159.038.28.112.364.084.084.206.126.364.126h.616V21h-.924c-.485 0-.877-.15-1.176-.448-.298-.299-.448-.69-.448-1.176V11.06h1.456Zm5.641 10.108c-.71 0-1.33-.159-1.862-.476a3.211 3.211 0 0 1-1.218-1.344c-.29-.588-.434-1.274-.434-2.058 0-.784.145-1.465.434-2.044.29-.588.695-1.04 1.218-1.358.532-.317 1.153-.476 1.862-.476.7 0 1.316.159 1.848.476.532.317.943.77 1.232 1.358.29.579.434 1.26.434 2.044s-.145 1.47-.434 2.058c-.29.579-.7 1.027-1.232 1.344-.532.317-1.148.476-1.848.476Zm0-1.274c.635 0 1.125-.229 1.47-.686.355-.457.532-1.097.532-1.918s-.177-1.46-.532-1.918c-.345-.457-.835-.686-1.47-.686-.644 0-1.139.229-1.484.686-.345.457-.518 1.097-.518 1.918s.173 1.46.518 1.918c.345.457.84.686 1.484.686Zm5.564-6.314 2.114 5.88 2.044-5.88h1.47l-2.968 8.288c-.15.43-.369.742-.658.938-.29.196-.663.294-1.12.294h-1.008v-1.19h.812a.729.729 0 0 0 .448-.126.71.71 0 0 0 .28-.364l.252-.63h-.462l-2.688-7.21h1.484Zm17.009-2.52v1.372h-4.956v2.912h4.788v1.344h-4.788v2.94h5.068V21h-6.552v-9.94h6.44Zm1.993 2.52h1.358l.056 1.568-.14-.21c.187-.495.481-.873.882-1.134.411-.261.91-.392 1.498-.392.7 0 1.288.177 1.764.532a3.09 3.09 0 0 1 1.064 1.4c.243.579.364 1.227.364 1.946 0 .719-.121 1.372-.364 1.96a3.194 3.194 0 0 1-1.064 1.4c-.476.345-1.064.518-1.764.518a3.18 3.18 0 0 1-1.064-.168 2.22 2.22 0 0 1-.798-.532 2.484 2.484 0 0 1-.504-.854l.168-.182V23.1h-1.456v-9.52Zm1.316 3.71c0 .467.07.896.21 1.288.149.392.373.71.672.952.299.243.672.364 1.12.364.663 0 1.157-.247 1.484-.742.336-.504.504-1.125.504-1.862 0-.728-.168-1.344-.504-1.848-.336-.504-.831-.756-1.484-.756-.448 0-.821.121-1.12.364a2.21 2.21 0 0 0-.672.952c-.14.392-.21.821-.21 1.288Zm8.644-3.71V21h-1.456v-7.42h1.456Zm.042-2.52v1.414h-1.512V11.06h1.512Zm6.939 5.11c-.065-.457-.261-.817-.588-1.078a1.722 1.722 0 0 0-1.134-.406c-.644 0-1.138.229-1.484.686-.345.457-.518 1.097-.518 1.918s.173 1.46.518 1.918c.346.457.84.686 1.484.686.458 0 .845-.14 1.162-.42.327-.29.532-.686.616-1.19l1.526.084a3.153 3.153 0 0 1-.588 1.498c-.308.42-.7.742-1.176.966a3.51 3.51 0 0 1-1.54.336c-.709 0-1.33-.159-1.862-.476a3.22 3.22 0 0 1-1.218-1.344c-.289-.588-.434-1.274-.434-2.058 0-.784.145-1.465.434-2.044.29-.588.696-1.04 1.218-1.358.532-.317 1.153-.476 1.862-.476.542 0 1.046.112 1.512.336.476.215.864.523 1.162.924.308.401.495.873.56 1.414l-1.512.084Zm7.806 1.54c.084.42.233.789.448 1.106.224.317.518.56.882.728.364.168.784.252 1.26.252a3.11 3.11 0 0 0 1.036-.154c.298-.103.527-.257.686-.462.158-.205.238-.453.238-.742 0-.457-.21-.835-.63-1.134-.411-.308-1.088-.579-2.03-.812-.98-.243-1.764-.593-2.352-1.05-.579-.457-.868-1.064-.868-1.82 0-.56.144-1.05.434-1.47.289-.42.686-.742 1.19-.966.513-.233 1.106-.35 1.778-.35.709 0 1.339.14 1.89.42.55.27.989.649 1.316 1.134a3.78 3.78 0 0 1 .616 1.666l-1.526.084a2.302 2.302 0 0 0-.392-1.022 2.01 2.01 0 0 0-.812-.686 2.533 2.533 0 0 0-1.12-.238c-.542 0-.985.13-1.33.392a1.211 1.211 0 0 0-.504 1.05c0 .327.107.597.322.812.224.205.485.369.784.49.298.112.7.238 1.204.378l.21.056c1.036.27 1.852.649 2.45 1.134.606.476.91 1.083.91 1.82 0 .597-.164 1.11-.49 1.54-.327.43-.766.756-1.316.98a4.783 4.783 0 0 1-1.778.322c-.738 0-1.405-.135-2.002-.406a3.52 3.52 0 0 1-1.414-1.19 3.59 3.59 0 0 1-.616-1.778l1.526-.084Zm9.703-5.81v6.986c0 .299.07.527.21.686.15.15.369.224.658.224h1.092V21h-1.218c-.718 0-1.264-.182-1.638-.546-.373-.364-.56-.887-.56-1.568V11.9h1.456Zm1.974 1.68v1.204h-4.55V13.58h4.55Zm1.247 2.212c.149-.737.499-1.316 1.05-1.736.551-.43 1.251-.644 2.1-.644 1.008 0 1.778.27 2.31.812.532.532.798 1.307.798 2.324v2.8c0 .168.037.29.112.364.075.075.187.112.336.112h.308V21h-.546c-.261 0-.504-.028-.728-.084a1.163 1.163 0 0 1-.574-.336c-.159-.168-.243-.406-.252-.714-.177.373-.471.686-.882.938-.411.243-.905.364-1.484.364-.775 0-1.414-.191-1.918-.574-.504-.383-.756-.896-.756-1.54 0-.476.107-.859.322-1.148.224-.29.532-.513.924-.672.401-.159.919-.299 1.554-.42l2.128-.42c-.009-.597-.149-1.04-.42-1.33-.271-.29-.681-.434-1.232-.434-.429 0-.784.107-1.064.322-.28.215-.476.527-.588.938l-1.498-.098Zm1.386 3.234c0 .29.121.527.364.714.252.187.611.28 1.078.28.383 0 .723-.089 1.022-.266.308-.187.546-.462.714-.826.177-.364.266-.807.266-1.33v-.07l-1.596.28-.266.042a8.367 8.367 0 0 0-.882.21.967.967 0 0 0-.504.322c-.131.159-.196.373-.196.644Zm11.831-2.856c-.065-.457-.261-.817-.588-1.078a1.722 1.722 0 0 0-1.134-.406c-.644 0-1.138.229-1.484.686-.345.457-.518 1.097-.518 1.918s.173 1.46.518 1.918c.346.457.84.686 1.484.686.458 0 .845-.14 1.162-.42.327-.29.532-.686.616-1.19l1.526.084a3.153 3.153 0 0 1-.588 1.498c-.308.42-.7.742-1.176.966a3.51 3.51 0 0 1-1.54.336c-.709 0-1.33-.159-1.862-.476a3.22 3.22 0 0 1-1.218-1.344c-.289-.588-.434-1.274-.434-2.058 0-.784.145-1.465.434-2.044.29-.588.696-1.04 1.218-1.358.532-.317 1.153-.476 1.862-.476.542 0 1.046.112 1.512.336.476.215.864.523 1.162.924.308.401.495.873.56 1.414l-1.512.084Zm4.558-5.11v6.216l3.304-3.696h1.876l-2.884 3.122L161.142 21h-1.708l-2.296-3.374-1.316 1.428V21h-1.456v-9.94h1.456Z"
                  />
                  <path
                    fill="#EDEDED"
                    fillRule="evenodd"
                    d="m15.03 12.697-.526 1.807-1.804.527L9 9l6.03 3.697Zm1.94 0 .526 1.807 1.804.527L23 9l-6.03 3.697Zm.526 4.8-.526 1.807L23 23l-3.7-6.03-1.804.526Zm-2.465 1.807-.527-1.808-1.804-.526L9 23l6.03-3.697h.001Z"
                    clipRule="evenodd"
                  />
                  <path stroke="#fff" strokeOpacity=".14" d="M31.5 1v30" />
                </svg>
              }
            />
            <LogoCard
              hasGrayscale={false}
              className="bg-black"
              logo={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="99"
                  height="32"
                  fill="none"
                  viewBox="0 0 99 32"
                >
                  <rect width="99" height="32" fill="#1A1A1A" rx="5" />
                  <rect
                    width="98"
                    height="31"
                    x=".5"
                    y=".5"
                    stroke="#fff"
                    strokeOpacity=".14"
                    rx="4.5"
                  />
                  <path
                    fill="#EDEDED"
                    d="M45.396 11.06c1.55 0 2.744.434 3.584 1.302.85.859 1.274 2.086 1.274 3.682 0 1.587-.415 2.81-1.246 3.668-.821.859-1.997 1.288-3.528 1.288h-3.262v-9.94h3.178Zm0 8.568c1.11 0 1.941-.299 2.492-.896.55-.597.826-1.493.826-2.688 0-1.213-.275-2.119-.826-2.716-.55-.597-1.381-.896-2.492-.896h-1.694v7.196h1.694Zm6.132-2.338c0-.784.145-1.465.434-2.044.29-.588.7-1.04 1.232-1.358.532-.317 1.148-.476 1.848-.476a3.3 3.3 0 0 1 1.638.406c.495.27.892.69 1.19 1.26.308.57.476 1.279.504 2.128l.014.504h-5.334c.056.7.257 1.241.602 1.624.346.383.808.574 1.386.574.374 0 .714-.098 1.022-.294.308-.205.537-.485.686-.84l1.526.112a3.116 3.116 0 0 1-1.218 1.666 3.44 3.44 0 0 1-2.016.616c-.7 0-1.316-.159-1.848-.476a3.183 3.183 0 0 1-1.232-1.344c-.289-.588-.434-1.274-.434-2.058Zm5.32-.7c-.093-.663-.303-1.148-.63-1.456a1.654 1.654 0 0 0-1.176-.462c-.54 0-.98.168-1.316.504-.336.336-.55.807-.644 1.414h3.766Zm3.21-3.01h1.358l.056 1.568-.14-.21c.186-.495.48-.873.882-1.134.41-.261.91-.392 1.498-.392.7 0 1.287.177 1.763.532.477.345.831.812 1.065 1.4.242.579.363 1.227.363 1.946 0 .719-.12 1.372-.364 1.96a3.196 3.196 0 0 1-1.064 1.4c-.475.345-1.063.518-1.763.518-.393 0-.747-.056-1.065-.168a2.22 2.22 0 0 1-.797-.532 2.494 2.494 0 0 1-.505-.854l.169-.182V23.1h-1.457v-9.52Zm1.316 3.71c0 .467.07.896.21 1.288.149.392.373.71.671.952.3.243.672.364 1.12.364.663 0 1.158-.247 1.484-.742.337-.504.505-1.125.505-1.862 0-.728-.169-1.344-.505-1.848-.335-.504-.83-.756-1.483-.756-.448 0-.822.121-1.12.364a2.2 2.2 0 0 0-.672.952c-.14.392-.21.821-.21 1.288Zm8.795-6.23v8.246c0 .159.038.28.112.364.084.084.206.126.364.126h.616V21h-.924c-.485 0-.877-.15-1.176-.448-.298-.299-.448-.69-.448-1.176V11.06h1.456Zm5.641 10.108c-.71 0-1.33-.159-1.862-.476a3.211 3.211 0 0 1-1.218-1.344c-.29-.588-.434-1.274-.434-2.058 0-.784.145-1.465.434-2.044.29-.588.695-1.04 1.218-1.358.532-.317 1.153-.476 1.862-.476.7 0 1.316.159 1.848.476.532.317.943.77 1.232 1.358.29.579.434 1.26.434 2.044s-.145 1.47-.434 2.058c-.29.579-.7 1.027-1.232 1.344-.532.317-1.148.476-1.848.476Zm0-1.274c.635 0 1.125-.229 1.47-.686.355-.457.532-1.097.532-1.918s-.177-1.46-.532-1.918c-.345-.457-.835-.686-1.47-.686-.644 0-1.139.229-1.484.686-.345.457-.518 1.097-.518 1.918s.173 1.46.518 1.918c.345.457.84.686 1.484.686Zm5.564-6.314 2.114 5.88 2.044-5.88h1.47l-2.968 8.288c-.15.43-.369.742-.658.938-.29.196-.663.294-1.12.294h-1.008v-1.19h.812a.729.729 0 0 0 .448-.126.71.71 0 0 0 .28-.364l.252-.63h-.462l-2.688-7.21h1.484Z"
                  />
                  <path
                    fill="#EDEDED"
                    fillRule="evenodd"
                    d="m15.03 12.697-.526 1.807-1.804.527L9 9l6.03 3.697Zm1.94 0 .526 1.807 1.804.527L23 9l-6.03 3.697Zm.526 4.8-.526 1.807L23 23l-3.7-6.03-1.804.526Zm-2.465 1.807-.527-1.808-1.804-.526L9 23l6.03-3.697h.001Z"
                    clipRule="evenodd"
                  />
                  <path stroke="#fff" strokeOpacity=".14" d="M31.5 1v30" />
                </svg>
              }
            />
            <LogoCard
              hasGrayscale={false}
              className="bg-white"
              logo={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="175"
                  height="32"
                  fill="none"
                  viewBox="0 0 175 32"
                >
                  <rect width="175" height="32" fill="#F7F7F7" rx="5" />
                  <rect
                    width="174"
                    height="31"
                    x=".5"
                    y=".5"
                    stroke="#1A1A1A"
                    strokeOpacity=".05"
                    rx="4.5"
                  />
                  <path
                    fill="#1A1A1A"
                    d="M45.424 11.06c1.577 0 2.79.434 3.64 1.302.859.859 1.288 2.086 1.288 3.682 0 1.587-.42 2.81-1.26 3.668-.83.859-2.025 1.288-3.584 1.288h-3.36v-9.94h3.276Zm0 8.386c1.045 0 1.825-.28 2.338-.84.523-.57.784-1.423.784-2.562 0-1.157-.261-2.016-.784-2.576-.513-.57-1.293-.854-2.338-.854h-1.512v6.832h1.512Zm6.145-2.156c0-.784.15-1.465.448-2.044a3.201 3.201 0 0 1 1.274-1.358c.55-.317 1.19-.476 1.918-.476.644 0 1.222.145 1.736.434.513.29.924.728 1.232 1.316.308.579.471 1.293.49 2.142v.462h-5.278c.037.635.214 1.13.532 1.484.317.345.746.518 1.288.518a1.678 1.678 0 0 0 1.582-1.036l1.778.126a3.141 3.141 0 0 1-1.26 1.694c-.607.41-1.307.616-2.1.616-.728 0-1.367-.159-1.918-.476a3.201 3.201 0 0 1-1.274-1.358c-.299-.588-.448-1.27-.448-2.044Zm5.306-.714c-.075-.607-.266-1.055-.574-1.344a1.51 1.51 0 0 0-1.092-.434c-.504 0-.91.159-1.218.476-.308.308-.504.742-.588 1.302h3.472Zm3.345-2.996h1.638l.056 1.554-.14-.182c.187-.495.48-.873.882-1.134.41-.27.905-.406 1.484-.406.69 0 1.274.173 1.75.518.476.345.83.812 1.064 1.4.243.579.364 1.232.364 1.96s-.121 1.386-.364 1.974a3.103 3.103 0 0 1-1.064 1.386c-.476.345-1.06.518-1.75.518a2.92 2.92 0 0 1-1.05-.182 2.22 2.22 0 0 1-.798-.532 2.476 2.476 0 0 1-.504-.868l.168-.14V23.1H60.22v-9.52Zm1.596 3.71c0 .448.065.859.196 1.232.14.364.35.658.63.882.28.224.62.336 1.022.336.607 0 1.064-.233 1.372-.7.317-.467.476-1.05.476-1.75 0-.69-.159-1.274-.476-1.75-.308-.476-.765-.714-1.372-.714-.401 0-.742.117-1.022.35-.28.224-.49.523-.63.896-.13.364-.196.77-.196 1.218Zm8.974-6.23v8.05c0 .168.042.299.126.392.094.084.224.126.392.126h.588V21h-1.022c-.55 0-.994-.163-1.33-.49-.326-.327-.49-.77-.49-1.33v-8.12h1.736Zm5.706 10.108c-.728 0-1.368-.159-1.918-.476a3.318 3.318 0 0 1-1.274-1.358c-.3-.588-.448-1.27-.448-2.044 0-.784.149-1.465.448-2.044a3.318 3.318 0 0 1 1.274-1.358c.55-.317 1.19-.476 1.918-.476s1.367.159 1.918.476c.55.317.975.77 1.274 1.358.298.579.448 1.26.448 2.044 0 .775-.15 1.456-.448 2.044a3.202 3.202 0 0 1-1.274 1.358c-.551.317-1.19.476-1.918.476Zm0-1.428c.597 0 1.054-.215 1.372-.644.317-.43.476-1.031.476-1.806 0-.775-.16-1.377-.476-1.806-.318-.43-.775-.644-1.372-.644-.588 0-1.046.215-1.372.644-.318.43-.476 1.031-.476 1.806 0 .775.158 1.377.476 1.806.326.43.784.644 1.372.644Zm5.854-6.16 1.988 5.6 1.932-5.6h1.708l-2.954 8.218c-.159.448-.392.775-.7.98-.308.215-.705.322-1.19.322H82v-1.344h.84c.205 0 .369-.042.49-.126a.71.71 0 0 0 .28-.364l.224-.546h-.518l-2.674-7.14h1.708Zm17.047-2.52v1.554h-4.872v2.632h4.704v1.526h-4.704v2.674h4.984V21h-6.748v-9.94h6.636Zm1.866 2.52h1.638l.056 1.554-.14-.182c.187-.495.481-.873.882-1.134.411-.27.905-.406 1.484-.406.691 0 1.274.173 1.75.518a3.09 3.09 0 0 1 1.064 1.4c.243.579.364 1.232.364 1.96s-.121 1.386-.364 1.974a3.101 3.101 0 0 1-1.064 1.386c-.476.345-1.059.518-1.75.518-.383 0-.733-.06-1.05-.182a2.22 2.22 0 0 1-.798-.532 2.464 2.464 0 0 1-.504-.868l.168-.14V23.1h-1.736v-9.52Zm1.596 3.71c0 .448.065.859.196 1.232.14.364.35.658.63.882.28.224.621.336 1.022.336.607 0 1.064-.233 1.372-.7.317-.467.476-1.05.476-1.75 0-.69-.159-1.274-.476-1.75-.308-.476-.765-.714-1.372-.714-.401 0-.742.117-1.022.35-.28.224-.49.523-.63.896-.131.364-.196.77-.196 1.218Zm8.767-3.71V21h-1.736v-7.42h1.736Zm.042-2.52v1.47h-1.806v-1.47h1.806Zm6.824 5.222c-.065-.457-.247-.812-.546-1.064a1.595 1.595 0 0 0-1.064-.378c-.588 0-1.045.215-1.372.644-.317.43-.476 1.031-.476 1.806 0 .775.159 1.377.476 1.806.327.43.784.644 1.372.644.439 0 .808-.13 1.106-.392.299-.27.486-.653.56-1.148l1.792.084a3.166 3.166 0 0 1-.574 1.54c-.317.43-.728.76-1.232.994a3.822 3.822 0 0 1-1.652.35c-.728 0-1.367-.159-1.918-.476a3.32 3.32 0 0 1-1.274-1.358c-.298-.588-.448-1.27-.448-2.044 0-.784.15-1.465.448-2.044a3.32 3.32 0 0 1 1.274-1.358c.551-.317 1.19-.476 1.918-.476.588 0 1.13.112 1.624.336.495.224.896.546 1.204.966.318.42.509.91.574 1.47l-1.792.098Zm8.181 1.386c.084.392.229.737.434 1.036.205.29.476.513.812.672.336.159.728.238 1.176.238.373 0 .691-.047.952-.14.271-.093.481-.233.63-.42.149-.187.219-.415.21-.686 0-.41-.191-.751-.574-1.022-.373-.28-.999-.527-1.876-.742-1.055-.252-1.876-.611-2.464-1.078-.588-.467-.882-1.078-.882-1.834 0-.579.145-1.083.434-1.512.299-.43.714-.76 1.246-.994.541-.233 1.162-.35 1.862-.35.719 0 1.358.14 1.918.42a3.24 3.24 0 0 1 1.344 1.148c.336.495.546 1.064.63 1.708l-1.792.098a1.94 1.94 0 0 0-.35-.966 1.84 1.84 0 0 0-.742-.644 2.343 2.343 0 0 0-1.036-.224c-.513 0-.929.121-1.246.364a1.122 1.122 0 0 0-.462.966c0 .29.098.532.294.728.205.196.448.35.728.462.28.103.649.215 1.106.336l.21.056c1.083.27 1.927.649 2.534 1.134.616.485.924 1.101.924 1.848 0 .607-.163 1.13-.49 1.568-.327.439-.77.77-1.33.994a4.933 4.933 0 0 1-1.848.336c-.765 0-1.456-.14-2.072-.42a3.586 3.586 0 0 1-1.456-1.19c-.355-.513-.56-1.11-.616-1.792l1.792-.098Zm9.909-5.768v6.846c0 .29.07.509.21.658.15.15.36.224.63.224h1.12V21h-1.386c-.756 0-1.33-.191-1.722-.574-.392-.383-.588-.943-.588-1.68V11.9h1.736Zm1.96 1.68v1.358h-4.858V13.58h4.858Zm1.186 2.254c.149-.765.508-1.358 1.078-1.778.569-.43 1.302-.644 2.198-.644 1.064 0 1.871.27 2.422.812.55.541.826 1.33.826 2.366v2.59c0 .196.037.336.112.42.084.075.2.112.35.112h.28V21l-.434.014h-.056c-.252.01-.509-.01-.77-.056a1.41 1.41 0 0 1-.672-.322c-.196-.168-.308-.425-.336-.77-.187.383-.49.695-.91.938-.42.243-.934.364-1.54.364-.766 0-1.405-.191-1.918-.574a1.859 1.859 0 0 1-.756-1.54c0-.467.107-.845.322-1.134.224-.29.532-.518.924-.686.401-.168.924-.313 1.568-.434l2.086-.42c-.01-.57-.136-.99-.378-1.26-.243-.28-.616-.42-1.12-.42-.392 0-.719.107-.98.322-.252.205-.425.509-.518.91l-1.778-.098Zm1.666 3.164c0 .27.112.495.336.672.233.168.564.252.994.252.345 0 .653-.084.924-.252.28-.168.494-.42.644-.756.158-.345.238-.76.238-1.246v-.07l-1.428.252-.252.042c-.346.065-.616.13-.812.196a1.011 1.011 0 0 0-.462.322c-.122.14-.182.336-.182.588Zm11.743-2.716c-.066-.457-.248-.812-.546-1.064a1.599 1.599 0 0 0-1.064-.378c-.588 0-1.046.215-1.372.644-.318.43-.476 1.031-.476 1.806 0 .775.158 1.377.476 1.806.326.43.784.644 1.372.644.438 0 .807-.13 1.106-.392.298-.27.485-.653.56-1.148l1.792.084a3.186 3.186 0 0 1-.574 1.54c-.318.43-.728.76-1.232.994a3.828 3.828 0 0 1-1.652.35c-.728 0-1.368-.159-1.918-.476a3.314 3.314 0 0 1-1.274-1.358c-.299-.588-.448-1.27-.448-2.044 0-.784.149-1.465.448-2.044a3.314 3.314 0 0 1 1.274-1.358c.55-.317 1.19-.476 1.918-.476.588 0 1.129.112 1.624.336a3 3 0 0 1 1.204.966c.317.42.508.91.574 1.47l-1.792.098Zm4.973-5.222v5.922l3.066-3.402h2.156l-2.898 3.08 3.024 4.34h-1.96l-2.198-3.29-1.19 1.288V21h-1.736v-9.94h1.736Z"
                  />
                  <path
                    fill="#1A1A1A"
                    fillRule="evenodd"
                    d="m15.03 12.697-.526 1.807-1.804.527L9 9l6.03 3.697Zm1.94 0 .526 1.807 1.804.527L23 9l-6.03 3.697Zm.526 4.8-.526 1.807L23 23l-3.7-6.03-1.804.526Zm-2.465 1.807-.527-1.808-1.804-.526L9 23l6.03-3.697h.001Z"
                    clipRule="evenodd"
                  />
                  <path stroke="#1A1A1A" strokeOpacity=".05" d="M31.5 1v30" />
                </svg>
              }
            />
            <LogoCard
              hasGrayscale={false}
              className="bg-white"
              logo={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="99"
                  height="32"
                  fill="none"
                  viewBox="0 0 99 32"
                >
                  <rect width="99" height="32" fill="#F7F7F7" rx="5" />
                  <rect
                    width="98"
                    height="31"
                    x=".5"
                    y=".5"
                    stroke="#1A1A1A"
                    strokeOpacity=".05"
                    rx="4.5"
                  />
                  <path
                    fill="#1A1A1A"
                    d="M45.424 11.06c1.577 0 2.79.434 3.64 1.302.859.859 1.288 2.086 1.288 3.682 0 1.587-.42 2.81-1.26 3.668-.83.859-2.025 1.288-3.584 1.288h-3.36v-9.94h3.276Zm0 8.386c1.045 0 1.825-.28 2.338-.84.523-.57.784-1.423.784-2.562 0-1.157-.261-2.016-.784-2.576-.513-.57-1.293-.854-2.338-.854h-1.512v6.832h1.512Zm6.145-2.156c0-.784.15-1.465.448-2.044a3.201 3.201 0 0 1 1.274-1.358c.55-.317 1.19-.476 1.918-.476.644 0 1.222.145 1.736.434.513.29.924.728 1.232 1.316.308.579.471 1.293.49 2.142v.462h-5.278c.037.635.214 1.13.532 1.484.317.345.746.518 1.288.518a1.678 1.678 0 0 0 1.582-1.036l1.778.126a3.141 3.141 0 0 1-1.26 1.694c-.607.41-1.307.616-2.1.616-.728 0-1.367-.159-1.918-.476a3.201 3.201 0 0 1-1.274-1.358c-.299-.588-.448-1.27-.448-2.044Zm5.306-.714c-.075-.607-.266-1.055-.574-1.344a1.51 1.51 0 0 0-1.092-.434c-.504 0-.91.159-1.218.476-.308.308-.504.742-.588 1.302h3.472Zm3.345-2.996h1.638l.056 1.554-.14-.182c.187-.495.48-.873.882-1.134.41-.27.905-.406 1.484-.406.69 0 1.274.173 1.75.518.476.345.83.812 1.064 1.4.243.579.364 1.232.364 1.96s-.121 1.386-.364 1.974a3.103 3.103 0 0 1-1.064 1.386c-.476.345-1.06.518-1.75.518a2.92 2.92 0 0 1-1.05-.182 2.22 2.22 0 0 1-.798-.532 2.476 2.476 0 0 1-.504-.868l.168-.14V23.1H60.22v-9.52Zm1.596 3.71c0 .448.065.859.196 1.232.14.364.35.658.63.882.28.224.62.336 1.022.336.607 0 1.064-.233 1.372-.7.317-.467.476-1.05.476-1.75 0-.69-.159-1.274-.476-1.75-.308-.476-.765-.714-1.372-.714-.401 0-.742.117-1.022.35-.28.224-.49.523-.63.896-.13.364-.196.77-.196 1.218Zm8.974-6.23v8.05c0 .168.042.299.126.392.094.084.224.126.392.126h.588V21h-1.022c-.55 0-.994-.163-1.33-.49-.326-.327-.49-.77-.49-1.33v-8.12h1.736Zm5.706 10.108c-.728 0-1.368-.159-1.918-.476a3.318 3.318 0 0 1-1.274-1.358c-.3-.588-.448-1.27-.448-2.044 0-.784.149-1.465.448-2.044a3.318 3.318 0 0 1 1.274-1.358c.55-.317 1.19-.476 1.918-.476s1.367.159 1.918.476c.55.317.975.77 1.274 1.358.298.579.448 1.26.448 2.044 0 .775-.15 1.456-.448 2.044a3.202 3.202 0 0 1-1.274 1.358c-.551.317-1.19.476-1.918.476Zm0-1.428c.597 0 1.054-.215 1.372-.644.317-.43.476-1.031.476-1.806 0-.775-.16-1.377-.476-1.806-.318-.43-.775-.644-1.372-.644-.588 0-1.046.215-1.372.644-.318.43-.476 1.031-.476 1.806 0 .775.158 1.377.476 1.806.326.43.784.644 1.372.644Zm5.854-6.16 1.988 5.6 1.932-5.6h1.708l-2.954 8.218c-.159.448-.392.775-.7.98-.308.215-.705.322-1.19.322H82v-1.344h.84c.205 0 .369-.042.49-.126a.71.71 0 0 0 .28-.364l.224-.546h-.518l-2.674-7.14h1.708Z"
                  />
                  <path
                    fill="#1A1A1A"
                    fillRule="evenodd"
                    d="m15.03 12.697-.526 1.807-1.804.527L9 9l6.03 3.697Zm1.94 0 .526 1.807 1.804.527L23 9l-6.03 3.697Zm.526 4.8-.526 1.807L23 23l-3.7-6.03-1.804.526Zm-2.465 1.807-.527-1.808-1.804-.526L9 23l6.03-3.697h.001Z"
                    clipRule="evenodd"
                  />
                  <path stroke="#1A1A1A" strokeOpacity=".05" d="M31.5 1v30" />
                </svg>
              }
            />
          </Grid>
        </article>
      </section>
    </div>
  )
}

const EpicStackSection = () => {
  return (
    <div>
      <h2
        id="epic-stack"
        className="w-full border-b border-black/5 pb-2 text-2xl font-bold dark:border-white/5"
      >
        Epic Stack
      </h2>
      <section className="space-y-12 pt-12">
        <article>
          <h3 className="pb-2 text-sm font-semibold uppercase tracking-wide">
            Logo Mark
          </h3>
          <Grid>
            <LogoCard
              className="bg-gray-900 dark:bg-gray-900/75"
              logo={<EpicStackMark variant="light" />}
            />
            <LogoCard
              className="bg-white"
              logo={<EpicStackMark variant="dark" />}
            />
          </Grid>
        </article>
        <article className="">
          <h3 className="pb-2 text-sm font-semibold uppercase tracking-wide">
            Horizontal Version
          </h3>
          <Grid>
            <LogoCard
              className="bg-[#140C3E]"
              logo={<EpicStackHorizontal variant="light" isGrayscale={false} />}
            />
            <LogoCard
              className="bg-white"
              logo={<EpicStackHorizontal variant="dark" isGrayscale={false} />}
            />
          </Grid>
        </article>
        <article>
          <h3 className="pb-2 text-sm font-semibold uppercase tracking-wide">
            Vertical Version
          </h3>
          <Grid>
            <LogoCard
              className="bg-[#140C3E]"
              logo={<EpicStackVertical variant="light" isGrayscale={false} />}
            />
            <LogoCard
              className="bg-white"
              logo={<EpicStackVertical variant="dark" isGrayscale={false} />}
            />
          </Grid>
        </article>
      </section>
    </div>
  )
}

const EpicWebSection = () => {
  return (
    <div>
      <h2
        id="epic-web"
        className="w-full border-b border-black/5 pb-2 text-2xl font-bold dark:border-white/5"
      >
        Epic Web
      </h2>
      <section className="space-y-12 pt-12">
        <article>
          <h3 className="pb-2 text-sm font-semibold uppercase tracking-wide">
            Logo Mark
          </h3>
          <Grid>
            <LogoCard
              className="bg-gray-900 dark:bg-gray-900/75"
              logo={<EpicWebMark variant="light" />}
            />
            <LogoCard
              className="bg-white"
              logo={<EpicWebMark variant="dark" />}
            />
          </Grid>
        </article>
        <article>
          <h3 className="pb-2 text-sm font-semibold uppercase tracking-wide">
            Vertical Version
          </h3>
          <Grid>
            <LogoCard
              className="bg-gray-900 dark:bg-gray-900/75"
              logo={<EpicWebVertical variant="light" />}
            />
            <LogoCard
              className="bg-white"
              logo={<EpicWebVertical variant="dark" />}
            />
          </Grid>
        </article>
        <article>
          <h3 className="pb-2 text-sm font-semibold uppercase tracking-wide">
            Horizontal Version
          </h3>
          <Grid>
            <LogoCard
              className="bg-gray-900 dark:bg-gray-900/75"
              logo={<EpicWebHorizontal variant="light" />}
            />
            <LogoCard
              className="bg-white"
              logo={<EpicWebHorizontal variant="dark" />}
            />
          </Grid>
        </article>
      </section>
    </div>
  )
}

const LogoCard: React.FC<
  React.PropsWithChildren<{
    logo: React.ReactElement
    className?: string
    hasGrayscale?: boolean
  }>
> = ({className, logo, hasGrayscale = true}) => {
  const [copiedState, setCopied] = useCopyToClipboard()
  const [isExpanded, setIsExpanded] = React.useState(false)
  const ref = React.useRef<HTMLDivElement>(null)
  const grayscaleLogo = React.createElement(logo.type, {
    ...logo.props,
    isGrayscale: true,
  })
  const [isGrayscale, setIsGrayscale] = React.useState(false)
  const logoEl = React.createElement(logo.type, {
    ...logo.props,
    isGrayscale,
  })
  return (
    <div>
      <div
        ref={ref}
        tabIndex={0}
        onMouseOver={() => {
          setIsExpanded(true)
        }}
        onMouseOut={() => {
          setIsExpanded(false)
        }}
        onFocus={() => {
          setIsExpanded(true)
        }}
        onBlur={(e) => {
          if (ref.current && !ref.current.contains(e.relatedTarget as Node)) {
            setIsExpanded(false)
          }
        }}
        className={twMerge(
          'relative flex aspect-video items-center justify-center rounded',
          className,
        )}
      >
        {logoEl}
        {isExpanded && (
          <div
            className={cx(
              'absolute bottom-3 right-3 flex items-center gap-2 text-black',
            )}
          >
            {hasGrayscale ? (
              <>
                <div className="py-1 pl-2 font-sans text-xs text-gray-500">
                  Copy SVG:
                </div>
                <button
                  type="button"
                  key={logo.props.variant}
                  className="rounded border border-gray-100/30 bg-gray-500/20 px-2 py-1 font-sans text-xs font-medium text-gray-500 hover:underline"
                  onClick={() => {
                    setCopied(renderToString(logo))
                    !copiedState.error && toast.success('Copied to clipboard')
                  }}
                >
                  Color
                </button>
                <button
                  onMouseOver={() => {
                    setIsGrayscale(true)
                  }}
                  onMouseOut={() => {
                    setIsGrayscale(false)
                  }}
                  onFocus={() => {
                    setIsGrayscale(true)
                  }}
                  onBlur={(e) => {
                    setIsGrayscale(false)
                  }}
                  type="button"
                  key={logo.props.variant}
                  className="rounded border border-gray-100/30 bg-gray-500/20 px-2 py-1 font-sans text-xs font-medium text-gray-500 hover:underline"
                  onClick={() => {
                    setCopied(renderToString(grayscaleLogo))
                    !copiedState.error && toast.success('Copied to clipboard')
                  }}
                >
                  Grayscale
                </button>
              </>
            ) : (
              <>
                <button
                  type="button"
                  key={logo.props.variant}
                  className="rounded border border-gray-100/30 bg-gray-500/20 px-2 py-1 font-sans text-xs font-medium text-gray-500 hover:underline"
                  onClick={() => {
                    setCopied(renderToString(logo))
                    !copiedState.error && toast.success('Copied to clipboard')
                  }}
                >
                  Copy SVG
                </button>
                <button
                  type="button"
                  key={logo.props.variant}
                  className="rounded border border-gray-100/30 bg-gray-500/20 px-2 py-1 font-sans text-xs font-medium text-gray-500 hover:underline"
                  onClick={() => {
                    const svg = new Blob([renderToString(logo)], {
                      type: 'image/svg+xml',
                    })
                    const url = URL.createObjectURL(svg)
                    const a = document.createElement('a')
                    a.href = url
                    a.download = 'logo.svg'
                    a.click()
                    URL.revokeObjectURL(url)
                  }}
                >
                  Download SVG
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

const Grid: React.FC<React.PropsWithChildren> = ({children}) => {
  return <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">{children}</div>
}

const EpicStackMark: React.FC<{variant?: 'light' | 'dark'}> = ({
  variant = 'light',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="65"
      fill="none"
      viewBox="0 0 65 65"
    >
      <path
        fill={variant === 'light' ? '#FFF' : '#000'}
        d="M39.445 25.555 37 17.163 65 0 47.821 28l-8.376-2.445Zm-13.89 0L28 17.163 0 0l17.179 28 8.376-2.445Zm13.89 13.89L37 47.837 65 65 47.821 37l-8.376 2.445Zm-13.89 0L28 47.837 0 65l17.179-28 8.376 2.445Z"
      />
    </svg>
  )
}

const EpicStackVertical: React.FC<{
  variant?: 'light' | 'dark'
  isGrayscale?: boolean
}> = ({variant, isGrayscale = true}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="112"
      fill="none"
      viewBox="0 0 100 112"
    >
      <path
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : '#D6C5FF'
            : isGrayscale
            ? '#000'
            : '#6A24FF'
        }
        d="M7.885 111.479c-3.652 0-6.356-1.812-7.388-4.795l2.23-1.283c.753 2.37 2.51 3.541 5.214 3.541 2.676 0 4.126-1.199 4.126-3.011 0-.92-.362-1.617-1.06-2.091-.696-.474-1.895-.948-3.54-1.478l-1.868-.613a29.066 29.066 0 0 1-1.617-.725c-.641-.335-1.115-.669-1.422-1.004-.641-.697-1.227-1.84-1.227-3.262 0-1.7.586-3.039 1.785-4.014 1.199-1.004 2.648-1.506 4.35-1.506 3.094 0 5.463 1.7 6.607 4.266L11.9 96.758c-.836-2.007-2.314-3.01-4.433-3.01-2.119 0-3.54 1.114-3.54 2.899 0 .864.306 1.505.92 1.951.613.446 1.672.92 3.178 1.394l1.143.363c.223.083.557.195 1.031.39.976.363 1.2.502 1.952.92.78.418 1.031.725 1.505 1.283.697.697.976 1.7.976 2.927 0 1.701-.613 3.067-1.868 4.098-1.254 1.004-2.871 1.506-4.879 1.506ZM19.587 91.6h14.08v2.454h-5.771v17.062H25.33V94.054h-5.744V91.6Zm35.025 19.516h-2.76l-1.59-4.377H41.48l-1.589 4.377h-2.76L44.408 91.6h2.927l7.277 19.516Zm-8.755-16.42-3.484 9.618h6.997l-3.512-9.619Zm23.703 16.783c-2.955 0-5.408-.976-7.332-2.928-1.924-1.951-2.871-4.349-2.871-7.193 0-2.843.947-5.241 2.871-7.193 1.924-1.951 4.377-2.927 7.333-2.927 3.568 0 6.747 1.84 8.42 4.74l-2.259 1.31c-1.115-2.147-3.485-3.54-6.161-3.54-2.259 0-4.099.724-5.52 2.174-1.422 1.45-2.12 3.262-2.12 5.436 0 2.147.697 3.959 2.12 5.409 1.421 1.45 3.261 2.175 5.52 2.175 2.676 0 5.046-1.394 6.161-3.513l2.258 1.282c-.808 1.45-1.98 2.621-3.485 3.485-1.505.865-3.15 1.283-4.934 1.283Zm20.836-10.399 8.894 10.036h-3.18l-8.42-9.367v9.367H85.1V91.6h2.593v8.811l8.14-8.81h3.179l-8.615 9.479Z"
      />
      <path
        fill={variant === 'light' ? '#FFF' : '#000'}
        fillRule="evenodd"
        d="M18.003 74.265v6.189h9.061v2.453H15.411V63.392h11.514v2.453h-8.922v5.994h8.225v2.426h-8.225Zm17.35-10.873h7.08c1.813 0 3.29.613 4.49 1.812 1.198 1.199 1.812 2.676 1.812 4.46 0 1.757-.614 3.262-1.812 4.461-1.2 1.2-2.677 1.813-4.49 1.813h-4.488v6.97h-2.593V63.39Zm2.592 10.12h4.489c1.087 0 1.98-.362 2.676-1.087.697-.753 1.06-1.673 1.06-2.76 0-2.23-1.59-3.848-3.736-3.848h-4.489v7.695Zm18.592 7.472V65.072h-2.949v-1.829h8.81v1.828H59.13v15.913h3.268v1.829H59.13v.094h-2.593v-.094h-2.949v-1.829h2.949Zm21.11 2.286c-2.956 0-5.41-.976-7.333-2.927-1.924-1.952-2.872-4.35-2.872-7.194 0-2.843.948-5.241 2.872-7.193 1.924-1.951 4.377-2.927 7.332-2.927 3.57 0 6.747 1.84 8.42 4.74l-2.258 1.31c-1.115-2.147-3.485-3.54-6.162-3.54-2.258 0-4.098.724-5.52 2.174-1.422 1.45-2.119 3.262-2.119 5.437 0 2.146.697 3.958 2.12 5.408 1.421 1.45 3.261 2.175 5.52 2.175 2.676 0 5.046-1.394 6.16-3.513l2.26 1.282c-.81 1.45-1.98 2.621-3.486 3.485-1.505.865-3.15 1.283-4.935 1.283Z"
        clipRule="evenodd"
      />
      <path
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : '#D6C5FF'
            : isGrayscale
            ? '#000'
            : '#6A24FF'
        }
        d="m46.177 13.174-1.806 6.197-6.185 1.806L25.5.5l20.677 12.674Zm6.646 0 1.806 6.197 6.186 1.806L73.5.5 52.823 13.174ZM54.63 29.63l-1.806 6.197L73.5 48.5 60.815 27.823l-6.186 1.806Zm-8.452 6.197-1.806-6.197-6.185-1.806L25.5 48.5l20.677-12.674Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  )
}

const EpicStackHorizontal: React.FC<{
  variant?: 'light' | 'dark'
  isGrayscale?: boolean
}> = ({variant, isGrayscale = true}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="228"
      height="48"
      fill="none"
      viewBox="0 0 228 48"
    >
      <path
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : '#D6C5FF'
            : isGrayscale
            ? '#000'
            : '#6A24FF'
        }
        d="m20.677 12.674-1.806 6.197-6.185 1.806L0 0l20.677 12.674Zm6.646 0 1.806 6.197 6.185 1.806L48 0 27.323 12.674ZM29.13 29.13l-1.806 6.197L48 48 35.314 27.323 29.13 29.13Zm-8.452 6.197-1.806-6.197-6.185-1.806L0 48l20.677-12.674Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : '#D6C5FF'
            : isGrayscale
            ? '#000'
            : '#6A24FF'
        }
        d="M145.523 33.556c-3.354 0-5.838-1.665-6.786-4.404l2.049-1.178c.691 2.176 2.304 3.252 4.788 3.252 2.458 0 3.79-1.101 3.79-2.766 0-.845-.333-1.485-.973-1.92-.64-.436-1.741-.871-3.252-1.357l-1.716-.564a26.477 26.477 0 0 1-1.485-.666c-.589-.307-1.024-.614-1.306-.921-.589-.64-1.127-1.69-1.127-2.996 0-1.562.538-2.792 1.639-3.688 1.101-.921 2.433-1.382 3.995-1.382 2.842 0 5.019 1.562 6.069 3.917l-1.998 1.153c-.768-1.844-2.125-2.766-4.071-2.766-1.946 0-3.252 1.024-3.252 2.663 0 .794.282 1.383.845 1.793.563.41 1.536.845 2.919 1.28l1.05.333c.205.077.512.18.947.358.897.333 1.101.461 1.793.845.717.384.947.666 1.382 1.178.641.64.897 1.562.897 2.689 0 1.562-.564 2.817-1.716 3.764-1.152.922-2.637 1.383-4.481 1.383Zm10.758-18.257h12.931v2.253h-5.301v15.67h-2.355v-15.67h-5.275v-2.253Zm31.804 17.924h-2.535l-1.46-4.02h-8.066l-1.459 4.02h-2.535l6.683-17.924h2.689l6.683 17.924Zm-8.041-15.082-3.2 8.834h6.427l-3.227-8.834Zm20.884 15.415c-2.714 0-4.967-.896-6.734-2.689-1.767-1.792-2.638-3.995-2.638-6.606 0-2.612.871-4.814 2.638-6.607 1.767-1.792 4.02-2.688 6.734-2.688 3.278 0 6.197 1.69 7.733 4.353l-2.074 1.203c-1.024-1.971-3.2-3.252-5.659-3.252-2.074 0-3.764.666-5.07 1.997-1.306 1.332-1.946 2.996-1.946 4.994 0 1.971.64 3.636 1.946 4.967 1.306 1.332 2.996 1.998 5.07 1.998 2.459 0 4.635-1.28 5.659-3.227l2.074 1.178c-.742 1.332-1.818 2.407-3.2 3.2-1.383.795-2.894 1.179-4.533 1.179Zm18.572-9.551 8.168 9.218h-2.919l-7.733-8.604v8.604h-2.382V15.299h2.382v8.091l7.477-8.091h2.919l-7.912 8.706Z"
      />
      <path
        fill={variant === 'light' ? '#FFF' : '#000'}
        d="M104.912 14.5h-8.094v1.679h2.875v17.044h2.381V16.18h2.838V14.5Zm-40.61 16.47v-5.685h7.554v-2.227h-7.554v-5.506h8.194V15.3H61.92v17.924h10.704V30.97h-8.322ZM86.74 15.299h-6.504v17.924h2.381v-6.401h4.123c1.664 0 3.021-.564 4.123-1.665 1.1-1.1 1.664-2.484 1.664-4.097 0-1.639-.563-2.996-1.665-4.097-1.1-1.1-2.458-1.664-4.122-1.664Zm0 9.295h-4.123v-7.068h4.123c1.972 0 3.431 1.486 3.431 3.534 0 .999-.333 1.844-.973 2.535-.64.666-1.46.999-2.458.999Zm25.606 6.273c1.767 1.793 4.021 2.689 6.735 2.689 1.639 0 3.149-.384 4.532-1.178 1.383-.794 2.458-1.87 3.201-3.2L124.74 28c-1.024 1.945-3.201 3.226-5.659 3.226-2.074 0-3.764-.666-5.07-1.997-1.306-1.332-1.946-2.996-1.946-4.968 0-1.997.64-3.662 1.946-4.993 1.306-1.332 2.996-1.998 5.07-1.998 2.458 0 4.635 1.28 5.659 3.252l2.074-1.203c-1.536-2.663-4.456-4.353-7.733-4.353-2.714 0-4.968.896-6.735 2.688-1.766 1.793-2.637 3.995-2.637 6.607s.871 4.814 2.637 6.606Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        fill={variant === 'light' ? '#FFF' : '#000'}
        d="M96.819 31.821h8.093V33.5h-8.094v-1.68Z"
      />
    </svg>
  )
}

const EpicWebMark: React.FC<{
  variant?: 'light' | 'dark'
  isGrayscale?: boolean
}> = ({variant = 'light', isGrayscale = false}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      fill="none"
      viewBox="0 0 70 70"
    >
      <path
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : 'url(#markGradient)'
            : isGrayscale
            ? '#000'
            : 'url(#markGradient)'
        }
        d="M36.277 33.738a64.504 64.504 0 0 1-4.257 2.15c-6.333 2.912-15.383 5.86-26.228 5.981l-1.249.014-.226-1.228a31.016 31.016 0 0 1-.531-5.638C3.786 17.804 17.787 3.802 35 3.802a31.05 31.05 0 0 1 13.295 2.975l4.146-2.113A34.774 34.774 0 0 0 35 0C15.712 0 0 15.712 0 35c0 7.7 2.504 14.83 6.74 20.617 7.252-1.235 11.802-4.14 11.802-4.14s-2.905 4.544-4.14 11.798A34.803 34.803 0 0 0 35 70c19.288 0 35-15.712 35-35a34.778 34.778 0 0 0-4.652-17.42l-2.11 4.138a31.037 31.037 0 0 1 2.976 13.299C66.214 52.23 52.213 66.23 35 66.23c-1.942 0-3.804-.196-5.635-.53l-1.231-.225.014-1.251c.12-10.854 3.069-19.903 5.98-26.234a64.386 64.386 0 0 1 2.149-4.253Z"
      />
      <path
        fill={variant === 'light' ? '#FFF' : isGrayscale ? '#000' : '#333753'}
        d="m53.235 27.155-8.03-2.344-2.345-8.047L69.5.5 53.235 27.155Z"
      />
      <defs>
        <linearGradient
          id="markGradient"
          x1="49.496"
          x2="20.585"
          y1="20.504"
          y2="49.431"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F75FF" />
          <stop offset="1" stopColor="#30AFFF" />
        </linearGradient>
      </defs>
    </svg>
  )
}

const EpicWebVertical: React.FC<{
  variant?: 'light' | 'dark'
  isGrayscale?: boolean
}> = ({variant, isGrayscale = false}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="152"
      height="111"
      fill="none"
      viewBox="0 0 152 111"
    >
      <g
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : '#FFF'
            : isGrayscale
            ? '#000'
            : '#333753'
        }
      >
        <path d="M2.893 101.357v6.19h9.06V110H.3V90.484h11.514v2.454H2.893v5.994h8.224v2.425H2.893Z" />
        <path
          fillRule="evenodd"
          d="M20.242 90.484h7.081c1.812 0 3.29.614 4.489 1.812 1.199 1.2 1.812 2.677 1.812 4.461 0 1.757-.613 3.262-1.812 4.461-1.199 1.199-2.677 1.812-4.489 1.812h-4.488V110h-2.593V90.484Zm2.593 10.121h4.488c1.088 0 1.98-.363 2.677-1.088.697-.752 1.06-1.672 1.06-2.76 0-2.23-1.59-3.847-3.737-3.847h-4.488v7.695Z"
          clipRule="evenodd"
        />
        <path d="M41.426 108.2V92.164h-3.09v-1.828h8.81v1.828h-3.127V108.2h3.127v1.828h-8.81V108.2h3.09Zm21.11 2.163c-2.956 0-5.409-.976-7.333-2.928-1.923-1.951-2.871-4.349-2.871-7.193 0-2.844.948-5.241 2.871-7.193 1.924-1.951 4.377-2.927 7.333-2.927 3.568 0 6.747 1.84 8.42 4.74l-2.259 1.31c-1.115-2.147-3.485-3.541-6.161-3.541-2.258 0-4.099.725-5.52 2.175-1.422 1.45-2.12 3.262-2.12 5.436 0 2.147.698 3.959 2.12 5.409 1.422 1.45 3.262 2.175 5.52 2.175 2.676 0 5.046-1.394 6.161-3.513l2.258 1.282c-.808 1.45-1.979 2.621-3.484 3.485-1.506.864-3.15 1.283-4.935 1.283Z" />
        <path
          fillRule="evenodd"
          d="M11.954 107.547V110H.3V90.484h11.514v2.454H2.893v5.994h8.224v2.425H2.893v6.19h9.06Zm-8.761-.3h9.06v3.053H0V90.184h12.114v3.054H3.193v5.394h8.224v3.025H3.193v5.59Zm16.749-17.063h7.381c1.89 0 3.444.643 4.701 1.9 1.257 1.257 1.9 2.811 1.9 4.673 0 1.833-.643 3.416-1.9 4.673-1.257 1.257-2.812 1.9-4.7 1.9h-4.19v6.97h-3.192V90.184ZM22.835 110h-2.593V90.484h7.081c1.812 0 3.29.614 4.489 1.812 1.199 1.2 1.812 2.677 1.812 4.461 0 1.757-.613 3.262-1.812 4.461-1.199 1.199-2.677 1.812-4.489 1.812h-4.488V110Zm15.502-17.836v-1.828h8.809v1.828h-3.127V108.2h3.127v1.828h-8.81V108.2h3.09V92.164h-3.09Zm2.79.3h-3.09v-2.428h9.409v2.428h-3.127V107.9h3.127v2.428h-9.41V107.9h3.09V92.464Zm30.238 2.507-2.79 1.618-.144-.279c-1.059-2.039-3.32-3.379-5.895-3.379-2.188 0-3.947.7-5.306 2.085-1.362 1.388-2.033 3.122-2.033 5.226 0 2.075.67 3.81 2.033 5.199 1.359 1.385 3.118 2.085 5.306 2.085 2.575 0 4.837-1.341 5.896-3.353l.144-.274 2.787 1.582-.145.26c-.837 1.5-2.048 2.709-3.598 3.599-1.554.892-3.25 1.323-5.084 1.323-3.028 0-5.561-1.003-7.546-3.017-1.982-2.011-2.958-4.486-2.958-7.404s.976-5.393 2.958-7.403c1.985-2.014 4.518-3.017 7.546-3.017 3.672 0 6.951 1.894 8.68 4.89l.149.259Zm-48.23 5.334h4.188c1.012 0 1.823-.334 2.459-.994.642-.695.977-1.541.977-2.554 0-2.072-1.462-3.547-3.436-3.547h-4.188v7.095ZM30 99.517c-.697.725-1.59 1.088-2.677 1.088h-4.488V92.91h4.488c2.147 0 3.736 1.617 3.736 3.847 0 1.087-.362 2.008-1.06 2.76Zm40.805 6.338c-.8 1.33-1.92 2.413-3.335 3.225-1.505.864-3.15 1.283-4.934 1.283-2.956 0-5.409-.976-7.333-2.928-1.923-1.951-2.871-4.349-2.871-7.193 0-2.844.948-5.241 2.871-7.193 1.924-1.951 4.377-2.927 7.333-2.927 3.462 0 6.556 1.731 8.265 4.482a9.171 9.171 0 0 1 .154.257l-2.258 1.31a5.921 5.921 0 0 0-.145-.262c-1.167-1.997-3.45-3.278-6.016-3.278-2.258 0-4.099.725-5.52 2.175-1.422 1.45-2.12 3.262-2.12 5.436 0 2.147.698 3.959 2.12 5.409 1.422 1.45 3.262 2.175 5.52 2.175 2.564 0 4.847-1.28 6.015-3.251.05-.086.1-.174.146-.262l2.258 1.282a3.841 3.841 0 0 1-.07.123l-.08.137Z"
          clipRule="evenodd"
        />
        <path d="M92.357 110h-3.01l-5.604-19.516h2.732l4.46 16.059 4.74-16.059h2.62l4.74 16.059 4.461-16.059h2.732L104.625 110h-3.011l-4.629-15.585L92.358 110Zm27.295-8.643v6.19h9.061V110h-11.654V90.484h11.514v2.454h-8.921v5.994h8.224v2.425h-8.224Zm28.222-1.477c1.784.864 2.927 2.509 2.927 4.6 0 1.561-.557 2.871-1.645 3.931-1.087 1.059-2.425 1.589-4.014 1.589h-8.42V90.484h7.806c1.534 0 2.816.502 3.876 1.534 1.059 1.031 1.589 2.286 1.589 3.791 0 1.729-.697 3.095-2.119 4.07Zm-3.346-6.97h-5.213v5.966h5.213c1.645 0 2.9-1.31 2.9-2.983 0-.809-.279-1.506-.864-2.091-.558-.586-1.227-.892-2.036-.892Zm-5.213 14.664h5.827c1.756 0 3.094-1.394 3.094-3.178 0-.864-.306-1.617-.92-2.23-.585-.614-1.31-.92-2.174-.92h-5.827v6.328Z" />
        <path
          fillRule="evenodd"
          d="M92.581 110.3h-3.46l-5.777-20.116h3.359l4.241 15.269 4.507-15.269h3.07l4.506 15.269 4.241-15.269h3.359l-5.776 20.116h-3.461l-4.404-14.831L92.58 110.3Zm-.224-.3h-3.01l-5.604-19.516h2.732l4.46 16.059 4.74-16.059h2.62l4.74 16.059 4.461-16.059h2.732L104.625 110h-3.011l-4.629-15.585L92.358 110Zm36.656-2.753v3.053h-12.254V90.184h12.114v3.053h-8.921v5.395h8.224v3.025h-8.224v5.59h9.061Zm-9.361.3v-6.19h8.224v-2.425h-8.224v-5.995h8.921v-2.453h-11.514V110h11.654v-2.453h-9.061Zm16.77 2.753V90.184h8.106c1.607 0 2.966.53 4.085 1.618 1.118 1.09 1.68 2.421 1.68 4.007 0 1.66-.616 3.019-1.861 4.029 1.635.957 2.669 2.6 2.669 4.642 0 1.641-.59 3.029-1.735 4.146-1.146 1.117-2.561 1.674-4.224 1.674h-8.72Zm11.752-10.265a6.424 6.424 0 0 0-.3-.155c.094-.065.185-.131.273-.2 1.238-.959 1.846-2.257 1.846-3.87 0-1.506-.53-2.761-1.589-3.793-1.06-1.031-2.342-1.533-3.876-1.533h-7.806V110h8.42c1.589 0 2.927-.53 4.014-1.589 1.088-1.06 1.645-2.37 1.645-3.931 0-1.972-1.016-3.547-2.627-4.445Zm-1.828-6.026c-.504-.53-1.097-.8-1.818-.8h-4.913v5.367h4.913c1.47 0 2.6-1.167 2.6-2.683 0-.73-.248-1.351-.777-1.88l-.005-.004Zm-1.818 4.867c1.645 0 2.9-1.31 2.9-2.983 0-.809-.279-1.506-.864-2.091-.558-.586-1.227-.892-2.036-.892h-5.213v5.966h5.213Zm2.576 3.502-.005-.005c-.527-.553-1.173-.827-1.957-.827h-5.527v5.728h5.527c1.582 0 2.794-1.25 2.794-2.878 0-.786-.275-1.462-.832-2.018Zm-7.789 5.196v-6.328h5.827c.864 0 1.589.306 2.174.92.614.613.92 1.366.92 2.23 0 1.784-1.338 3.178-3.094 3.178h-5.827Z"
          clipRule="evenodd"
        />
      </g>
      <path
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : 'url(#markGradient)'
            : isGrayscale
            ? '#000'
            : 'url(#markGradient)'
        }
        d="M77.277 33.738a64.504 64.504 0 0 1-4.257 2.15c-6.333 2.912-15.383 5.86-26.228 5.981l-1.249.014-.226-1.228a31.01 31.01 0 0 1-.531-5.638C44.786 17.804 58.787 3.802 76 3.802a31.05 31.05 0 0 1 13.295 2.975l4.146-2.113A34.774 34.774 0 0 0 76 0C56.712 0 41 15.712 41 35c0 7.7 2.504 14.83 6.74 20.617 7.252-1.235 11.802-4.14 11.802-4.14s-2.905 4.544-4.14 11.798A34.803 34.803 0 0 0 76 70c19.288 0 35-15.712 35-35a34.779 34.779 0 0 0-4.652-17.42l-2.111 4.138a31.039 31.039 0 0 1 2.977 13.299C107.214 52.23 93.213 66.23 76 66.23c-1.942 0-3.804-.196-5.635-.53l-1.231-.225.014-1.251c.12-10.854 3.069-19.903 5.98-26.234a64.386 64.386 0 0 1 2.149-4.253Z"
      />
      <path
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : '#FFF'
            : isGrayscale
            ? '#000'
            : '#333753'
        }
        d="m94.235 27.155-8.03-2.344-2.345-8.047L110.5.5 94.235 27.155Z"
      />
      {!isGrayscale && (
        <defs>
          <linearGradient
            id="markGradient"
            x1="90.496"
            x2="61.585"
            y1="20.504"
            y2="49.431"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4F75FF" />
            <stop offset="1" stopColor="#30AFFF" />
          </linearGradient>
        </defs>
      )}
    </svg>
  )
}

const EpicWebHorizontal: React.FC<{
  variant?: 'light' | 'dark'
  isGrayscale?: boolean
}> = ({variant, isGrayscale = false}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="264"
      height="70"
      fill="none"
      viewBox="0 0 264 70"
    >
      <g
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : '#FFF'
            : isGrayscale
            ? '#000'
            : '#333753'
        }
      >
        <path d="M92.593 36.536v6.189h9.061v2.453H90V25.662h11.515v2.454h-8.922v5.994h8.225v2.426h-8.225Z" />
        <path
          fillRule="evenodd"
          d="M109.942 25.662h7.081c1.813 0 3.29.614 4.489 1.813 1.199 1.198 1.812 2.676 1.812 4.46 0 1.757-.613 3.262-1.812 4.461-1.199 1.199-2.676 1.812-4.489 1.812h-4.488v6.97h-2.593V25.662Zm2.593 10.12h4.488c1.088 0 1.98-.362 2.677-1.086.697-.753 1.059-1.673 1.059-2.76 0-2.231-1.589-3.848-3.736-3.848h-4.488v7.695Z"
          clipRule="evenodd"
        />
        <path d="M131.126 43.379V27.342h-3.089v-1.828h8.809v1.828h-3.127V43.38h3.127v1.828h-8.809V43.38h3.089Zm21.11 2.161c-2.955 0-5.409-.975-7.332-2.927-1.924-1.951-2.872-4.349-2.872-7.193 0-2.843.948-5.241 2.872-7.193 1.923-1.951 4.377-2.927 7.332-2.927 3.569 0 6.747 1.84 8.42 4.74l-2.259 1.31c-1.115-2.147-3.485-3.54-6.161-3.54-2.258 0-4.098.724-5.52 2.174-1.422 1.45-2.119 3.262-2.119 5.436 0 2.147.697 3.96 2.119 5.41 1.422 1.449 3.262 2.174 5.52 2.174 2.676 0 5.046-1.394 6.161-3.513l2.259 1.282c-.809 1.45-1.98 2.621-3.485 3.485-1.506.865-3.151 1.283-4.935 1.283Z" />
        <path
          fillRule="evenodd"
          d="M101.654 42.725v2.453H90V25.662h11.515v2.454h-8.922v5.994h8.225v2.426h-8.225v6.189h9.061Zm-8.761-.3h9.061v3.053H89.7V25.362h12.115v3.054h-8.922v5.394h8.225v3.026h-8.225v5.589Zm16.749-17.063h7.381c1.889 0 3.444.643 4.701 1.9 1.257 1.257 1.9 2.812 1.9 4.673 0 1.834-.643 3.416-1.9 4.673-1.257 1.257-2.812 1.9-4.701 1.9h-4.188v6.97h-3.193V25.362Zm2.893 19.816h-2.593V25.662h7.081c1.813 0 3.29.614 4.489 1.813 1.199 1.198 1.812 2.676 1.812 4.46 0 1.757-.613 3.262-1.812 4.461-1.199 1.199-2.676 1.812-4.489 1.812h-4.488v6.97Zm15.502-17.836v-1.828h8.809v1.828h-3.127V43.38h3.127v1.828h-8.809V43.38h3.089V27.342h-3.089Zm2.789.3h-3.089v-2.428h9.409v2.428h-3.127V43.08h3.127v2.428h-9.409V43.08h3.089V27.642Zm30.239 2.507-2.789 1.618-.145-.279c-1.059-2.038-3.32-3.379-5.895-3.379-2.188 0-3.947.7-5.306 2.085-1.362 1.388-2.033 3.123-2.033 5.226 0 2.076.671 3.81 2.033 5.199 1.359 1.386 3.118 2.085 5.306 2.085 2.575 0 4.837-1.341 5.896-3.353l.144-.274 2.787 1.583-.145.26c-.837 1.499-2.047 2.708-3.598 3.599-1.554.891-3.25 1.322-5.084 1.322-3.028 0-5.561-1.003-7.546-3.017-1.982-2.01-2.958-4.485-2.958-7.404 0-2.918.976-5.392 2.958-7.403 1.985-2.014 4.518-3.017 7.546-3.017 3.672 0 6.951 1.894 8.68 4.89l.149.259Zm-48.23 5.334h4.188c1.012 0 1.823-.334 2.459-.993.643-.696.977-1.542.977-2.555 0-2.072-1.462-3.547-3.436-3.547h-4.188v7.095Zm6.865-.787c-.697.724-1.589 1.087-2.677 1.087h-4.488v-7.695h4.488c2.147 0 3.736 1.617 3.736 3.847 0 1.088-.362 2.008-1.059 2.76Zm40.805 6.337c-.8 1.33-1.92 2.413-3.334 3.225-1.506.865-3.151 1.283-4.935 1.283-2.955 0-5.409-.976-7.332-2.928-1.924-1.951-2.872-4.349-2.872-7.193 0-2.843.948-5.241 2.872-7.193 1.923-1.951 4.377-2.927 7.332-2.927 3.462 0 6.556 1.732 8.266 4.482l.131.218.023.04-2.259 1.31a6.226 6.226 0 0 0-.144-.263c-1.168-1.997-3.451-3.278-6.017-3.278-2.258 0-4.098.725-5.52 2.175-1.422 1.45-2.119 3.262-2.119 5.436 0 2.147.697 3.96 2.119 5.41 1.422 1.449 3.262 2.174 5.52 2.174 2.565 0 4.848-1.28 6.015-3.251.051-.086.1-.173.146-.262l2.259 1.282-.07.123c-.027.046-.053.092-.081.137Z"
          clipRule="evenodd"
        />
        <path d="M174.058 45.178h-3.011l-5.604-19.516h2.732l4.461 16.06 4.739-16.06h2.621l4.74 16.06 4.46-16.06h2.733l-5.604 19.516h-3.011l-4.628-15.585-4.628 15.585Zm27.294-8.643v6.19h9.061v2.453h-11.654V25.662h11.515v2.454h-8.922v5.994h8.225v2.425h-8.225Zm28.222-1.477c1.784.864 2.928 2.509 2.928 4.6 0 1.561-.558 2.872-1.645 3.931-1.088 1.06-2.426 1.59-4.015 1.59h-8.42V25.661h7.807c1.533 0 2.815.502 3.875 1.534 1.059 1.031 1.589 2.286 1.589 3.791 0 1.729-.697 3.095-2.119 4.07Zm-3.345-6.97h-5.214v5.966h5.214c1.644 0 2.899-1.31 2.899-2.983 0-.809-.279-1.506-.864-2.091-.558-.585-1.227-.892-2.035-.892Zm-5.214 14.665h5.827c1.756 0 3.095-1.394 3.095-3.179 0-.864-.307-1.617-.92-2.23-.586-.613-1.311-.92-2.175-.92h-5.827v6.329Z" />
        <path
          fillRule="evenodd"
          d="M174.281 45.478h-3.46l-5.777-20.116h3.359l4.241 15.27 4.507-15.27h3.069l4.507 15.27 4.241-15.27h3.359l-5.776 20.116h-3.461l-4.404-14.83-4.405 14.83Zm-.223-.3h-3.011l-5.604-19.516h2.732l4.461 16.06 4.739-16.06h2.621l4.74 16.06 4.46-16.06h2.733l-5.604 19.516h-3.011l-4.628-15.585-4.628 15.585Zm36.655-2.753v3.053h-12.254V25.362h12.115v3.054h-8.922v5.394h8.225v3.026h-8.225v5.589h9.061Zm-9.361.3v-6.19h8.225V34.11h-8.225v-5.994h8.922v-2.454h-11.515v19.516h11.654v-2.453h-9.061Zm16.77 2.753V25.362h8.107c1.607 0 2.966.53 4.084 1.619 1.118 1.088 1.68 2.42 1.68 4.006 0 1.66-.615 3.019-1.861 4.029 1.635.957 2.67 2.6 2.67 4.642 0 1.642-.59 3.03-1.736 4.146-1.146 1.117-2.561 1.674-4.224 1.674h-8.72Zm11.752-10.264a6.066 6.066 0 0 0-.3-.156c.094-.065.185-.131.273-.2 1.238-.958 1.846-2.256 1.846-3.87 0-1.506-.53-2.76-1.589-3.792-1.06-1.032-2.342-1.534-3.875-1.534h-7.807v19.516h8.42c1.589 0 2.927-.53 4.015-1.589 1.087-1.06 1.645-2.37 1.645-3.931 0-1.971-1.017-3.546-2.628-4.444Zm-1.827-6.027c-.505-.53-1.097-.8-1.818-.8h-4.914v5.367h4.914c1.469 0 2.599-1.166 2.599-2.683 0-.73-.248-1.35-.776-1.879l-.005-.005Zm-1.818 4.867c1.644 0 2.899-1.31 2.899-2.983 0-.809-.279-1.506-.864-2.091-.558-.585-1.227-.892-2.035-.892h-5.214v5.966h5.214Zm2.575 3.502-.005-.005c-.527-.553-1.173-.827-1.957-.827h-5.527v5.729h5.527c1.582 0 2.795-1.251 2.795-2.879a2.75 2.75 0 0 0-.833-2.018Zm-7.789 5.197v-6.329h5.827c.864 0 1.589.307 2.175.92.613.613.92 1.366.92 2.23 0 1.785-1.339 3.179-3.095 3.179h-5.827Z"
          clipRule="evenodd"
        />
        <path d="M239.041 32.853a.89.89 0 0 1-1.254 0 .89.89 0 0 1 0-1.254.89.89 0 0 1 1.254 0 .889.889 0 0 1 0 1.254Zm2.753-7.187h2.904c1.003 0 1.839.355 2.508 1.055.679.7 1.013 1.567 1.013 2.6 0 1.035-.334 1.902-1.013 2.602-.669.7-1.505 1.055-2.508 1.055h-2.904v-7.313Zm1.442 5.933h1.462c.638 0 1.15-.209 1.547-.627.397-.428.595-.971.595-1.65 0-.68-.198-1.223-.595-1.64-.397-.429-.909-.637-1.547-.637h-1.462v4.554Zm8.753-1.64v1.64h3.082v1.379h-4.524v-7.313h4.471v1.38h-3.029V28.6h2.768v1.358h-2.768Zm8.997 3.019H259.2l-2.455-7.313h1.567l1.786 5.62 1.776-5.62h1.578l-2.466 7.313Z" />
      </g>
      <path
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : 'url(#markGradient)'
            : isGrayscale
            ? '#000'
            : 'url(#markGradient)'
        }
        d="M36.277 33.738a64.504 64.504 0 0 1-4.257 2.15c-6.333 2.912-15.383 5.86-26.228 5.981l-1.249.014-.226-1.228a31.016 31.016 0 0 1-.531-5.638C3.786 17.804 17.787 3.802 35 3.802a31.05 31.05 0 0 1 13.295 2.975l4.146-2.113A34.774 34.774 0 0 0 35 0C15.712 0 0 15.712 0 35c0 7.7 2.504 14.83 6.74 20.617 7.252-1.235 11.802-4.14 11.802-4.14s-2.905 4.544-4.14 11.798A34.803 34.803 0 0 0 35 70c19.288 0 35-15.712 35-35a34.778 34.778 0 0 0-4.652-17.42l-2.11 4.138a31.037 31.037 0 0 1 2.976 13.299C66.214 52.23 52.213 66.23 35 66.23c-1.942 0-3.804-.196-5.635-.53l-1.231-.225.014-1.251c.12-10.854 3.069-19.903 5.98-26.234a64.386 64.386 0 0 1 2.149-4.253Z"
      />
      <path
        fill={
          variant === 'light'
            ? isGrayscale
              ? '#FFF'
              : '#FFF'
            : isGrayscale
            ? '#000'
            : '#333753'
        }
        d="m53.235 27.155-8.03-2.344-2.345-8.047L69.5.5 53.235 27.155Z"
      />
      <defs>
        <linearGradient
          id="markGradient"
          x1="49.496"
          x2="20.585"
          y1="20.504"
          y2="49.431"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F75FF" />
          <stop offset="1" stopColor="#30AFFF" />
        </linearGradient>
      </defs>
    </svg>
  )
}

const EpicWebCampSection = () => {
  return (
    <div>
      <h2
        id="epic-web"
        className="w-full border-b border-black/5 pb-2 text-2xl font-bold dark:border-white/5"
      >
        Epic Web Camp
      </h2>
      <section className="space-y-12 pt-12">
        <article>
          <h3 className="pb-2 text-sm font-semibold uppercase tracking-wide">
            Logo Mark
          </h3>
          <Grid>
            <LogoCard
              className="bg-gray-900 dark:bg-gray-900/75"
              logo={<EpicWebCampMark variant="light" />}
            />
            <LogoCard
              className="bg-white"
              logo={<EpicWebCampMark variant="dark" />}
            />
          </Grid>
        </article>
      </section>
    </div>
  )
}

const EpicWebCampMark: React.FC<{
  variant?: 'light' | 'dark'
  isGrayscale?: boolean
}> = ({variant, isGrayscale = false}) => {
  return (
    <>
      <svg
        className="w-32"
        width="313"
        height="372"
        viewBox="0 0 313 372"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M156.05 209.747C154.085 216.564 151.871 223.312 149.407 229.97C138.614 259.146 119.372 297.007 85.5563 331.614L81.666 335.597L77.0775 332.433C70.1149 327.661 63.6012 322.271 57.6261 316.312C3.34182 261.991 3.33185 173.613 57.6261 119.292C72.1099 104.769 89.6361 93.649 108.938 86.7217L115.352 66.9678C88.9678 74.0349 64.9179 87.9394 45.6361 107.294C-15.1918 168.163 -15.1918 267.332 45.6361 328.21C69.9154 352.506 100.299 367.109 131.91 372C150.883 345.219 156.07 321.692 156.07 321.692C156.07 321.692 161.237 345.199 180.22 371.99C212.868 366.939 243.053 351.607 266.394 328.21C327.222 267.342 327.222 168.173 266.394 107.294C247.132 87.9694 223.122 74.0748 196.788 66.9977L203.182 86.7117C222.494 93.629 240.02 104.759 254.514 119.292C308.798 173.613 308.798 261.981 254.514 316.302C248.389 322.431 241.895 327.691 235.073 332.413L230.484 335.587L226.584 331.594C192.728 296.957 173.496 259.097 162.703 229.93C160.24 223.282 158.025 216.544 156.07 209.727L156.05 209.747Z"
          fill={
            variant === 'light'
              ? isGrayscale
                ? '#FFF'
                : '#5CFFBB'
              : isGrayscale
              ? '#000'
              : '#009F5D'
          }
        />
        <path
          d="M188.778 135.452L156.06 153.4L123.282 135.402L156.01 0L188.778 135.452Z"
          fill={
            variant === 'light'
              ? isGrayscale
                ? '#FFF'
                : '#F8F8F9'
              : isGrayscale
              ? '#000'
              : '#303030'
          }
        />
        <path
          d="M245.377 307.188C268.02 284.53 280.968 254.714 282.195 222.783L276.359 198.657L258.853 271.104L246.763 221.126L236.609 263.139L222.245 203.767L206.654 268.26L197.726 231.337L190.644 260.653C200.479 279.05 213.885 299.313 232.06 318.697C236.928 315.054 241.317 311.261 245.387 307.198L245.377 307.188Z"
          fill={
            variant === 'light'
              ? isGrayscale
                ? '#FFF'
                : '#328769'
              : isGrayscale
              ? '#000'
              : '#14B67D'
          }
        />
        <path
          d="M66.5841 307.188C43.9407 284.53 30.993 254.714 29.7661 222.783L35.6015 198.657L53.1078 271.104L65.1975 221.126L75.3522 263.139L89.7162 203.767L105.307 268.26L114.235 231.337L121.317 260.653C111.482 279.05 98.0753 299.313 79.9008 318.697C75.0329 315.054 70.6439 311.261 66.5741 307.198L66.5841 307.188Z"
          fill={
            variant === 'light'
              ? isGrayscale
                ? '#FFF'
                : '#328769'
              : isGrayscale
              ? '#000'
              : '#14B67D'
          }
        />
        <path
          d="M82.1945 136.321L85.0573 153.709L102.434 156.574C102.713 156.624 102.713 157.023 102.434 157.063L85.0573 159.928L82.1945 177.316C82.1446 177.595 81.7456 177.595 81.7057 177.316L78.8429 159.928L61.4663 157.063C61.187 157.013 61.187 156.614 61.4663 156.574L78.8429 153.709L81.7057 136.321C81.7556 136.041 82.1546 136.041 82.1945 136.321Z"
          fill={
            variant === 'light'
              ? isGrayscale
                ? '#FFF'
                : '#F8F8F9'
              : isGrayscale
              ? '#000'
              : '#303030'
          }
        />
        <path
          d="M116.21 177.625L117.666 186.499L126.534 187.956C126.673 187.976 126.673 188.186 126.534 188.206L117.666 189.663L116.21 198.537C116.19 198.677 115.98 198.677 115.96 198.537L114.504 189.663L105.636 188.206C105.496 188.186 105.496 187.976 105.636 187.956L114.504 186.499L115.96 177.625C115.98 177.486 116.19 177.486 116.21 177.625Z"
          fill={
            variant === 'light'
              ? isGrayscale
                ? '#FFF'
                : '#F8F8F9'
              : isGrayscale
              ? '#000'
              : '#303030'
          }
        />
        <path
          d="M229.856 136.321L226.993 153.709L209.616 156.574C209.337 156.624 209.337 157.023 209.616 157.063L226.993 159.928L229.856 177.316C229.905 177.595 230.304 177.595 230.344 177.316L233.207 159.928L250.584 157.063C250.863 157.013 250.863 156.614 250.584 156.574L233.207 153.709L230.344 136.321C230.295 136.041 229.896 136.041 229.856 136.321Z"
          fill={
            variant === 'light'
              ? isGrayscale
                ? '#FFF'
                : '#F8F8F9'
              : isGrayscale
              ? '#000'
              : '#303030'
          }
        />
        <path
          d="M195.841 177.625L194.384 186.499L185.516 187.956C185.377 187.976 185.377 188.186 185.516 188.206L194.384 189.663L195.841 198.537C195.861 198.677 196.07 198.677 196.09 198.537L197.546 189.663L206.414 188.206C206.554 188.186 206.554 187.976 206.414 187.956L197.546 186.499L196.09 177.625C196.07 177.486 195.861 177.486 195.841 177.625Z"
          fill={
            variant === 'light'
              ? isGrayscale
                ? '#FFF'
                : '#F8F8F9'
              : isGrayscale
              ? '#000'
              : '#303030'
          }
        />
      </svg>
    </>
  )
}
